import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import PropTypes from 'prop-types';
import Button from '../Button';
import { apiUrls } from '../../../constants/apiUrl';
// import { logError, FE_JS_ERROR } from '../../../services/loggerService';
import logger from './logger_new';
import { getUrlName, isEUPFlow, TechFlow } from '../Helpers/index';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    if (isEUPFlow() !== 'true' && TechFlow() !== 'true') {
      // window.addEventListener('error', logError);
      window.addEventListener('error', logger);
    }
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  redirect5Ghome = () => {
    window.location.href = apiUrls().redirect5Ghome;
  };

  createLoggerObject = (error) => ({
    json: true,
    eventType: 'FeError',
    message: error.message || '',
    note: `from Page: ${getUrlName(window.location.href)} - Error Type: ${error.name}`,
    messageType: 'ERROR',
    errorCategory: 'UIError',
    networkError: {
      error,
      message: error.message || '',
      stack: error.stack || '',
      subEventType: 'FeErrorJ',
    },
  });

  componentDidCatch(error, info) {
    if (isEUPFlow() !== 'true' && TechFlow() !== 'true') {
      // logError('errorBoundary', error, FE_JS_ERROR, info);
      // logger(error, info);
      logger(this.createLoggerObject(error), info);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Grid>
          <Row className="displayBlock">
            <Col colSizes={{ mobile: 4, tablet: 9, desktop: 9 }} className="noMargin noPadding">
              <div className="col-xs-12 col-sm-12 col-lg-12 col-xl-12 alignCenter marginTop">
                <h4 className="normal">Something went wrong.</h4>
                <Button className="myverizon" primary onClick={() => this.redirect5Ghome()}>
                  Back to 5G Home
                </Button>
              </div>
            </Col>
          </Row>
        </Grid>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  children: PropTypes.any,
};
